import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import { computed, PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationWrapper',
  props: {
  disabled: Boolean,
  extraLimitOptions: {
    type: Array as PropType<number[]>,
    default: () => []
  },

  limit: {
    type: Number,
    required: true
  },

  page: {
    type: Number,
    required: true
  },

  totalCount: {
    type: Number,
    required: true
  }
},
  emits: ["update:page", "update:limit"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:page', page: number): void
  (e: 'update:limit', limit: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const limitOptions = [10, 20, 30, 40, 50]

const rowOptions = computed(() =>
  [...limitOptions, ...props.extraLimitOptions].sort((a, b) => a - b)
)

const totalPages = computed(() => Math.ceil(props.totalCount / props.limit))
const hasPrevPage = computed(() => props.page > 1)
const hasNextPage = computed(() => props.page !== totalPages.value)
const from = computed(() => {
  return props.page * props.limit - props.limit + 1
})
const to = computed(() => {
  const maxCountOnPage = props.limit * props.page

  return maxCountOnPage > props.totalCount ? props.totalCount : maxCountOnPage
})
const pagesToDisplay = computed(() => {
  const middlePagesToDisplay = [] as Array<string | number>

  if (totalPages.value <= 7) {
    return [...Array(totalPages.value + 1).keys()].splice(1)
  }

  if (props.page < 4) {
    middlePagesToDisplay.push(2, 3, 4, 5, '...')
  } else if (totalPages.value - 3 <= props.page) {
    middlePagesToDisplay.push(
      '...',
      totalPages.value - 4,
      totalPages.value - 3,
      totalPages.value - 2,
      totalPages.value - 1
    )
  } else {
    middlePagesToDisplay.push(
      '...',
      props.page - 1,
      props.page,
      props.page + 1,
      '...'
    )
  }

  return [1, ...middlePagesToDisplay, totalPages.value]
})

function handleClickEvent(page: number | string) {
  if (!props.disabled && typeof page !== 'string') {
    emit('update:page', Number(page))
  }
}

function handleNextEvent() {
  if (!props.disabled && hasNextPage.value) {
    emit('update:page', props.page + 1)
  }
}

function handlePrevEvent() {
  if (!props.disabled && hasPrevPage.value) {
    emit('update:page', props.page - 1)
  }
}

function handleUpdateLimit(limit: number) {
  emit('update:limit', limit)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "summary", {
      from: _unref(from),
      to: _unref(to)
    }, () => [
      _hoisted_1
    ]),
    _renderSlot(_ctx.$slots, "default", {
      hasPrevPage: _unref(hasPrevPage),
      hasNextPage: _unref(hasNextPage),
      handleClickEvent: handleClickEvent,
      handleNextEvent: handleNextEvent,
      handlePrevEvent: handlePrevEvent,
      pagesToDisplay: _unref(pagesToDisplay),
      totalPages: _unref(totalPages)
    }),
    _renderSlot(_ctx.$slots, "row-select", {
      rowOptions: _unref(rowOptions),
      handleUpdateLimit: handleUpdateLimit
    }, () => [
      _hoisted_2
    ])
  ]))
}
}

})